<template>
  <div class="marketing-page">
    <PortalHeader />
    <main class="marketing-main">
      <section class="page-hero">
        <div class="container hero-inner">
          <slot name="hero" />
        </div>
      </section>
      <section class="page-body">
        <div class="container body-inner">
          <slot />
        </div>
      </section>
    </main>
    <PortalFooter />
  </div>
</template>

<script>
import PortalHeader from '@/components/portal/PortalHeader.vue'
import PortalFooter from '@/components/portal/PortalFooter.vue'

export default {
  name: 'MarketingPageShell',
  components: { PortalHeader, PortalFooter }
}
</script>

<style scoped>
.marketing-page {
  min-height: 100vh;
  background: var(--bg-page, #fcfcfc);
}

.marketing-main {
  padding-top: var(--header-height, 64px);
}

.page-hero {
  padding: 48px 0 36px;
  background:
    radial-gradient(circle at 15% 20%, rgba(25, 118, 210, 0.16), transparent 50%),
    radial-gradient(circle at 85% 0%, rgba(25, 118, 210, 0.12), transparent 45%),
    linear-gradient(180deg, #fafaff 0%, #fff 100%);
  border-bottom: 1px solid #eef0f4;
}

.hero-inner {
  max-width: 920px;
}

.page-body {
  padding: 48px 0 72px;
}

.body-inner {
  width: 100%;
}
</style>
